import type { ReactNode } from 'react';

import Colors from '@rockalingua/ui/constants/Colors';

import Text from '../Typography/Text';
import {
  Container,
  FeatureItem as StyledFeatureItem,
  IconContainer,
} from './FeatureGrid.styled';

type FeatureGridSize = 'default' | 'compact';

type FeatureGridProps = {
  items: FeatureGridItem[];
  size?: FeatureGridSize;
};

export default function FeatureGrid({
  items,
  size = 'default',
}: FeatureGridProps) {
  const isCompact = size == 'compact';
  const titleVariant = isCompact ? 'title-small-grey-22' : 'title-mid-grey-32';
  const descriptionVariant = isCompact ? 'grey-14-medium' : 'grey-16-medium';

  return (
    <Container $size={size}>
      {items.map((item) => (
        <StyledFeatureItem key={item.title} $size={size}>
          <IconContainer
            $backgroundColor={item.iconBackgroundColor}
            $size={size}
          >
            {item.icon}
          </IconContainer>
          <Text variant={titleVariant} color={Colors.BLACK}>
            {item.title}
          </Text>
          <Text variant={descriptionVariant} color={Colors.BLACK}>
            {item.description}
          </Text>
        </StyledFeatureItem>
      ))}
    </Container>
  );
}

export type FeatureGridItem = {
  icon: ReactNode;
  iconBackgroundColor: string;
  title: string;
  description: string | ReactNode;
};

export type { FeatureGridProps, FeatureGridSize };
